import { Star } from "lucide-react";

/** Stelle 1-5: in sola lettura (valore decimale) o selezionabili con onChange. */
export const Stelle = ({ valore = 0, onChange, size = 16, testid = "stelle" }) => (
  <span className="inline-flex items-center gap-0.5" data-testid={testid}>
    {[1, 2, 3, 4, 5].map((n) => (
      <button key={n} type="button" disabled={!onChange} onClick={() => onChange?.(n)} aria-label={`${n} stelle`} className={`${onChange ? "cursor-pointer hover:scale-110 transition-transform" : "cursor-default"} disabled:cursor-default`} data-testid={`${testid}-${n}`}>
        <Star size={size} className={n <= Math.round(valore) ? "fill-amber-400 text-amber-400" : "text-slate-300"} />
      </button>
    ))}
  </span>
);

export const RiepilogoStelle = ({ r, testid = "riepilogo-stelle" }) => r?.n > 0
  ? <span className="inline-flex items-center gap-1.5 text-xs text-slate-700" data-testid={testid}><Stelle valore={r.media} size={13} testid={`${testid}-icone`} /><b>{r.media}</b><span className="text-slate-500">({r.n} {r.n === 1 ? "valutazione" : "valutazioni"})</span></span>
  : <span className="text-[11px] text-slate-400" data-testid={testid}>Nessuna valutazione ancora</span>;
